// extracted by mini-css-extract-plugin
export default {"userIdentityContainer":"styles_userIdentityContainer__uYXCV","userIdentity":"styles_userIdentity__GcK9m","name":"styles_name__C7Bjn"};